import { render, staticRenderFns } from "./topInformations.vue?vue&type=template&id=e675c20c&"
import script from "./topInformations.vue?vue&type=script&lang=js&"
export * from "./topInformations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports